function getMerchantCustomStyleSheetUrl(merchantId: string, bucketName: string): string {
  return `https://storage.googleapis.com/${bucketName}/stylesheets/${merchantId}.css`;
}

export {getMerchantCustomStyleSheetUrl};
